export default Object.freeze([
  { value: 'bdoCards', text: 'Wszystkie' },
  { value: 'revisionIndex', text: 'Korekty' },
  { value: 'assigningBdoCards', text: 'Przydzielanie' },
  { value: 'internalBdoCards', text: 'Przekazanie' },
  { value: 'bdoCardTemplates', text: 'Szablony' }
])
